<template> 
    <div>
        <!-- Header Slider -->
        <div v-if="slideImages && slideImages.length" class="mb-4 mb-lg-10">
            <v-carousel :show-arrows-on-hover="phoneOnly" cycle :height="pcOnly ? 325 : 110" interval="10000" :show-arrows="slideImages.length > 1" class="header-carousel" hide-delimiters :class="{'bordered': (!slideImages || !slideImages.length)}">
                <template v-slot:prev="{ on, attrs }">
                    <v-btn color="primary" v-bind="attrs" v-on="on" class="transparent" depressed>
                        <v-icon large>mdi-chevron-left</v-icon>
                    </v-btn>
                </template>
                <template v-slot:next="{ on, attrs }">
                    <v-btn color="primary" v-bind="attrs" v-on="on" class="transparent" depressed>
                        <v-icon large>mdi-chevron-right</v-icon>
                    </v-btn>
                </template>
                <v-carousel-item v-for="(img,i) in slideImages" :key="i" class="slide-image">
                    <a v-if="img.href" :href="img.href" :target="capRunning ? '_system' : '_blank'">
                        <div :style="`width: 100%; height: 100%; background-image: url(${img.url}); background-size: cover; background-position: center;`" class="p-relative">
                            
                        </div>
                    </a>
                    <div v-else :style="`width: 100%; height: 100%; background-image: url(${img.url}); background-size: cover; background-position: center;`" />
                    <!-- <v-img :src="img.url" center contain></v-img> -->
                </v-carousel-item>
            </v-carousel>
        </div>


        <div class="mb-5 home-items" :class="phoneOnly ? 'home-items--phone-grid' : 'd-flex flex-wrap'">
            <v-card flat :to="{name: 'calendar'}" class="home-item bordered d-flex justify-center align-center flex-column pa-3 rounded" v-ripple="false">
                <div class="mb-2">
                    <v-icon color="primary" size="30">mdi-calendar</v-icon>
                </div>
                <div class="text--text text-center">Calendar</div>
            </v-card>

            <v-card flat :to="{name: 'my-students'}" class="home-item bordered d-flex justify-center align-center flex-column pa-3 rounded" :class="{'ms-3': pcOnly}" v-ripple="false">
                <div class="mb-2">
                    <v-icon color="teal darken-1" size="30">mdi-account-group</v-icon>
                </div>
                <div class="text--text text-center">My Students</div>
            </v-card>

            <v-card flat @click="addClassDialog = true" class="home-item bordered d-flex justify-center align-center flex-column pa-3 rounded" :class="{'ms-3': pcOnly}" v-ripple="false">
                <div class="mb-2">
                    <v-icon color="indigo darken-1" size="30">mdi-sync</v-icon>
                </div>
                <div class="text--text text-center">Make-up Class</div>
            </v-card>

            <v-card flat :to="{name: 'salary-report'}" class="home-item bordered d-flex justify-center align-center flex-column pa-3 rounded" :class="{'ms-3': pcOnly}" v-ripple="false">
                <div class="mb-2">
                    <v-icon color="secondary darken-1" size="30">mdi-cash-multiple</v-icon>
                </div>
                <div class="text--text text-center">Salary</div>
            </v-card>
        </div>

        <v-row>
            <v-col v-if="!nextClass && (!otherNextClasses || otherNextClasses.length === 0)"  cols="12">
                <v-alert color="grey" text>
                    <div class="text--text">You don't have next classes, <router-link :to="{name: 'courses'}">Check our courses</router-link>.</div>
                </v-alert>
            </v-col>
            <v-col v-if="nextClass" cols="12" lg="6">
                <v-card class="bordered rounded px-lg-2 py-lg-1 mb-3">
                    <v-card-title class="pb-1">Next Class</v-card-title>
                    <class-card :class-data="nextClass" :reloading="loading" no-dialog />
                </v-card>
            </v-col>
            <v-col v-if="otherNextClasses && otherNextClasses.length" cols="12" lg="6">
                <v-card>
                    <v-list class="py-0">
                        <class-list-item v-for="(classData) in otherNextClasses" :key="classData.id" :class-data="classData" class="mb-3" />
                        <v-list-item dense class="bordered rounded overflow-hidden" :to="{name: 'calendar'}" v-ripple="false">
                            <v-list-item-content>
                                <v-list-item-title class="text--text">
                                    <v-icon size="20" class="me-2">mdi-calendar</v-icon>
                                    <span>My Calendar</span>
                                </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-icon>
                                <v-icon>mdi-chevron-right</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-col>
        </v-row>
        <v-card class="bordered px-2 py-1 mb-3">
            <v-card-title>
                <v-icon left :color="rescheduleRequests.length ? 'indigo darken-2' : ''">mdi-clock-edit</v-icon>
                Reschedule Requests
                <!-- <span v-if="rescheduleRequests.length" class="indigo--text text--darken-2 ms-2">({{rescheduleRequests.length}})</span> -->
            </v-card-title>
            <!-- <v-card-subtitle class="mb-2">Open calendar to view more classes</v-card-subtitle> -->
            <v-card-text :class="{'px-0': phoneOnly && rescheduleRequests.length}">
                <v-alert v-if="!rescheduleRequests.length" text color="muted" type="info" icon="mdi-information-outline" :dense="phoneOnly">
                    <div :class="{'details-text': phoneOnly}">
                        No requests found.
                    </div>
                </v-alert>
                <div v-else>
                    <reschedule-requests :requests="rescheduleRequests" />
                </div>
            </v-card-text>
        </v-card>

        <v-dialog transition="slide-y-transition" v-model="addClassDialog" max-width="450px">
            <!-- <action-dialog button-color="primary" action="post" url="/classes" success-msg="Class has been added successfully" title="Add Makup Class" subtitle="" button-text="Confirm" :data="{...addClassForm, enrollment_id: enrollment.id}" @reset="teacherHourlyPrice = ''" @sync="makeupClassDone"> -->
            <v-card>
                <v-card-title>
                    <v-icon color="indigo darken-1" class="me-2">mdi-sync</v-icon>
                    Add make-up class
                </v-card-title>
                <!-- <v-card-subtitle>Add custom class directly</v-card-subtitle> -->
                <v-card-text class="pt-4">
                    <v-alert v-if="addClassForm.date === today" text dense type="info" color="text" class="details-text">
                        <span class="strong-text--text">you can't choose time before {{now}}</span>
                    </v-alert>

                    <v-select v-model="addClassForm.enrollment_id" filled :items="enrollmentsItems" :menu-props="{offsetY: true}" label="Student" hide-details class="mb-5" placeholder="Choose Student"></v-select>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-menu ref="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field hide-details placeholder="Class Day" v-model="addClassForm.date" label="Day" filled class="mb-5" readonly v-bind="attrs" v-on="on"></v-text-field>
                                </template>
                                <v-date-picker ref="picker" :min="today" v-model="addClassForm.date" @change="saveMenu" color="primary" landscape no-title></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="6">
                            <time-input v-model="addClassForm.start_time" :min="addClassForm.date === today ? now : null" :outlined="false" filled half-format label="Class Time" placeholder="Class Time" class="mb-5" />
                        </v-col>
                    </v-row>
                    <!-- <time-input v-model="addClassForm.end_time" :min="addClassForm.date === today ? now : null" :outlined="false" half-format label="End Time (optional)" placeholder="Class End Time" /> -->
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text color="muted" :disabled="addingClass" @click="addClassDialog = false">Cancel</v-btn>
                    <v-btn text color="primary" :disabled="addingClass" :loading="addingClass" @click="addMakeupClass">Confirm</v-btn>
                </v-card-actions>
            </v-card>
            <!-- </action-dialog> -->
        </v-dialog>
    </div>
</template>

<script>
import CourseCard from '@/components/custom/course-card'
import UpcomingClassCard from '@/components/custom/upcoming-class-card'
import RescheduleRequests from './reschedule-requests'
import TimeInput from '@/components/custom/time-input'

import ClassCard from '@/components/custom/class-card'
import ClassListItem from '@/components/custom/class-list-item'

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    props: {
        loading: {type: Boolean, default: false}
    },
    data(){
        let d = new Date();
        return {
            today: d.toISOString().substr(0, 10),
            now: d.toTimeString().substr(0, 5),

            addClassDialog: false,
            addingClass: false,
            addClassForm: {
                enrollment_id: '',
                date: '',
                start_time: '',
                // end_time: '',
            },
            
            interval: null,
        }
    },
    components: {
        UpcomingClassCard,
        CourseCard,
        RescheduleRequests,
        ClassCard,
        ClassListItem,
        TimeInput
    },
    computed: {
        ...GlobalComputed,
        homeData(){
            return this.$store.state.userModule.homeData;
        },
        monthDoneDurationHours(){
            return parseFloat((this.homeData.month_done_duration/60).toFixed(2));
        },
        nextClass(){
            return this.homeData ? this.homeData.next_class : null;
        },
        otherNextClasses(){
            return this.homeData ? this.homeData.other_next_classes : null;
        },
        rescheduleRequests(){
            return this.homeData ? this.homeData.reschedule_requests : null;
        },
        enrollmentsItems(){
            return this.homeData ? this.homeData.enrollments.map(enrollment=>{
                return {text: `${enrollment.student.name} - ${enrollment.course.name}`, value: enrollment.id};
            }) : [];
        },
        slideImages(){
            return this.homeData ? this.homeData.slide_images : [];
        }
    },
    methods: {
        addMakeupClass(){
            if (!this.addingClass){
                this.addingClass = true;
                this.$store.dispatch('addMakeupClass', {data: this.addClassForm}).then(response=>{
                    this.addingClass = false;
                    this.addClassDialog = false;
                    this.showMsg('Class has been added successfully', 'success');
                    Object.assign(this.addClassForm, {
                        date: '',
                        start_time: '',
                    })
                }).catch(e=>{
                    this.addingClass = false;
                    this.showMsg('Error occurred during preforming your action', 'error');
                })
            }
        },
        saveMenu(date){
            this.$refs.menu.save(date);
        },
        percentFormat(value){
            return Math.round(value * 10) / 10;
        },
        ...GlobalMethods
    },
    created(){
        const timeout = this.appData.home_reload_timeout || 10000;
        this.interval = window.setInterval(()=>{
            this.$emit('load');
        }, timeout)
    },
    beforeDestroy(){
        window.clearInterval(this.interval);
    }
}
</script>

<style lang="scss" scoped>
    .header-carousel{
        border-radius: 10px!important;
        border-radius: 5px;
        border: 1px solid rgba(#000, 0.1);
    }
    .home-items--phone-grid{
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 12px;
        align-content: start;
        .home-item{
            margin-top: 0;
        }
    }
    .home-item{
        transition: 0.2s ease-in-out all;
        margin-top: 5px;
        user-select: none;
        @media(max-width: 959px){
            width: 100%;
            min-width: 0;
        }
        @media(min-width: 960px){
            width: 110px;
            height: 100px;
        }
        font-weight: 500;
        font-size: 13px;
        line-height: 1.45;

        &:hover{
            transform: translateY(-2px);
        }
        &:active{
            transform: scale(0.96);
        }
    }
</style>
<style lang="scss">
.v-window__prev, .v-window__next{
    background: none!important;
}
.v-carousel__controls{
    background: none!important;
    .v-carousel__controls__item{
        margin: 0 2px!important;

        .v-icon.mdi-circle{
            font-size: 15px!important;
        }
    }
}
</style>
